function toggleMiniCart() {
  const cartEl = document.getElementById('mini_cart')
  const classList =  cartEl.classList 
  
  const isOpen = classList.contains('open')

  if (isOpen) {
    classList.remove('open')
  } else {
    classList.add('open')
  }
}

async function getCartItems() {
  try {
    const res = await fetch(`${window.Shopify.routes.root}cart.js`)
    const data = await res.json()
    return data 

  } catch (error) {
    console.log('getCartItems', error)
  }
}
getCartItems()


async function updateCart() {
  const res = await fetch(window.Shopify.routes.root + '?sections=mini-cart')
  const data = await res.json()
  const cartSection = document.getElementById('shopify-section-mini-cart')
  cartSection.outerHTML = data['mini-cart']
  setTimeout(() => {
    toggleMiniCart()
  }, 500)
}

async function updateCartWithoutToggle() {
  const res = await fetch(window.Shopify.routes.root + '?sections=mini-cart')
  const data = await res.json()
  const cartSection = document.getElementById('shopify-section-mini-cart')
  const htmlString = data['mini-cart'].replace('class="mini_cart"', 'class="mini_cart open"')
  cartSection.outerHTML = htmlString
}


function toggleMiniCartLoading() {
  const cartEl = document.getElementById('mini_cart')
  const classList =  cartEl.classList 
  
  const isLoading = classList.contains('loading')

  if (isLoading) {
    classList.remove('loading')
  } else {
    classList.add('loading')
  }
}


document.addEventListener('toggleMiniCart', toggleMiniCart)
document.addEventListener('updateCart', updateCart)
document.addEventListener('updateCartWithoutToggle', updateCartWithoutToggle)
document.addEventListener('toggleMiniCartLoading', toggleMiniCartLoading)